import { ModulePackFE_ColorGroup, ModulePackFE_DiseaseProfileDB, ModulePackFE_DiseaseValueDB, ModulePackFE_DiseaseViewDB, ModulePackFE_MultiVar } from './_entity.js';
export const ModulePackFE_DiseaseProfile = [
    ...ModulePackFE_DiseaseValueDB,
    ...ModulePackFE_DiseaseViewDB,
    ...ModulePackFE_DiseaseProfileDB,
    ...ModulePackFE_ColorGroup,
    ...ModulePackFE_MultiVar,
];
//# sourceMappingURL=module-pack.js.map